export class CoilSelectionCriteria {

  fluidType!: string;
  glycolPercent!: string;
  dryBulbTemperature!: number;
  wetBulbTemperature!: number;
  fluidTemperature!: number;
  fluidFlowRate!: number;
  temperatureChange!: number;
  targetType!: string;
  targetValue!: number;

}
